import React from 'react';
import styled from 'styled-components';

interface AdminMemberInfoProps {
  label: string;
  value: string;
  href?: string;
}

const AdminMemberInfo: React.FC<AdminMemberInfoProps> = ({
  label,
  value,
  href,
}) => {
  return (
    <Info>
      <InfoLabel>{label}:</InfoLabel>
      <InfoValue>
        {href ? (
          <InfoLink
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {value}
          </InfoLink>
        ) : value}
      </InfoValue>
    </Info>
  );
};

const Info = styled.div`
  height: 18px;
  padding-right: 4px;
  margin-bottom: 1px;
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ theme }) => theme.typography.Body_04};
`;

const InfoLabel = styled.span`
  min-width: 140px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  font-weight: 500;
`;

const InfoValue = styled.span`
  color: ${({ theme }) => theme.colors.color_Gray_01};
  flex: 1;
`;

const InfoLink = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export default AdminMemberInfo;
